export { default } from './MinPrepayment';
